<template>
  <div class="main-content">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" size="small" :model="formInline" class="user-search">
      <el-form-item label="账号：">
        <el-input size="small" v-model="formInline.accountNoLike" placeholder="请输入账号"></el-input>
      </el-form-item>
      <el-form-item label="姓名：">
        <el-input size="small" v-model="formInline.userNameLike" placeholder="请输入姓名"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search()">搜索</el-button>
        <!-- <el-button size="small" type="primary" @click="dropdownBtn()">下载模版</el-button>
        <el-button size="small" type="primary" @click="showExportDialog()" plain>导入</el-button> -->
        <el-button size="small" type="primary" @click="handleEdit()" v-buttonAuth="'system:user:add'">创建用户</el-button>
      </el-form-item>
    </el-form>
    <div class="main-table">
      <my-table :columns="tableForm.customColumns" :tableData="tableForm.tableData" :loading="tableForm.isLoading">
        <template #gender="item">
          <div class="col-29f cs-pit">
            {{ item.row.gender }}
          </div>
        </template>
        <el-table-column align="center" prop="userSex" label="操作">
          <template slot-scope="scope">
            <el-button v-buttonAuth="'system:user:edit'" type="text"
              @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-popconfirm title="确定启用吗？" v-if="!scope.row.status" @confirm="handleStatus(scope.$index, scope.row)">
              <el-button type="text" slot="reference" v-buttonAuth="'system:user:status'">启用</el-button>
            </el-popconfirm>
            <el-popconfirm title="确定禁用吗？" v-if="scope.row.status" @confirm="handleStatus(scope.$index, scope.row)">
              <el-button type="text" slot="reference" class="col-f4d" v-buttonAuth="'system:user:status'">禁用</el-button>
            </el-popconfirm>
            <el-popconfirm title="确定重置密码吗？" v-if="scope.row.status" @confirm="resetPassword(scope.$index, scope.row)">
              <el-button type="text" slot="reference" class="col-f4d" v-buttonAuth="'system:user:reset'">重置密码</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </my-table>
    </div>
    <div class="main-pagination">
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </div>
    <el-dialog :title="title" :visible.sync="editFormVisible" custom-class="form-dialog" width="70%"
      @close='closeDialog()'>
      <my-form :form-config="formConfig.formItems" ref="editForm" :formRules="formConfig.formRules" @submit="submitForm"
        :dataForm="formConfig.dataForm">
      </my-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='editFormVisible = false;'>取消</el-button>
        <el-button size="small" type="primary" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>

    <!-- 导入 -->
    <myImportDialog :exportUploadProperty="exportUploadProperty" :visible="exportDialog.visible" :file-size="100"
      :getResult="exportRes" @close="closeExportDialog"></myImportDialog>
  </div>
</template>

<script>
import MyTable from '@/components/myTable.vue';
import Pagination from '@/components/Pagination'
import myForm from '@/components/myForm.vue';
import { capitalEnglishList, fileDownload } from "@/utils/util.js";
import { userPage, userAdd, userEdit, userRemove, userImport, userImportRes, userEnableOrDisable, remakePasswd } from '@/api/userMG.js'
import { roleList } from '@/api/roleMG.js'

import MyUpload from "@/components/myUpload.vue";
import myImportDialog from "@/components/myImportDialog.vue";
export default {
  components: {
    MyTable,
    Pagination,
    myForm,
    MyUpload,
    myImportDialog
  },
  data () {
    return {
      formInline: {
        accountNoLike: '',
        userNameLike: ''
      },
      tableForm: {
        customColumns: [
          { label: '姓名', prop: 'userName' },
          { label: '账号', prop: 'accountNo' },
          { label: '角色', prop: 'roleList', formatter: (item) => { return item.map(el => { return el.roleName }).join(',') } },
          { label: '状态', prop: 'status', formatter: (item) => { return item ? '启用' : '<span style="color:red">停用</span>' } },
          { label: '人员类型', prop: 'userType', formatter: (item) => { return item == 'admin' ? '管理员' : item == 'user' ? '普通用户' : '访客' } },
        ],
        tableData: [
        ],
        isLoading: false,
      },
      dialogVisible: false,
      dialogImageUrl: '',

      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加用户',
      // 编辑与添加
      formConfig: {
        formItems: [
          {
            type: 'select', prop: 'userType', label: '用户类型', span: 12, disable: true, options: [{ id: 'admin', label: '管理员' }, { id: 'user', label: '普通用户' }, { id: 'visitor', label: '访客' }]
          },
          { type: 'input', prop: 'userName', label: '姓名', span: 12 },
          { type: 'input', prop: 'accountNo', label: '账号', span: 12 },
          {
            type: 'select', prop: 'roleIdList', label: '角色', span: 12, options: []
            , property: {
              clearable: true,
              filterable: true,
              multiple: true,
            },
          },
          {
            type: 'select', prop: 'status', label: '状态类型', span: 12, options: [{ id: true, label: '启用' }, { id: false, label: '禁用' }]
          },
          // Add more form items as needed
        ],
        formRules: {
          accountNo: [
            { required: true, message: '请输入账号/手机号', trigger: 'blur' },
            { pattern: /^1[3456789]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
          ],
          userName: [
            { required: true, message: '请输入用户名称', trigger: 'blur' },
            // 可以添加其他验证规则
          ],
          roleIdList: [
            { required: true, message: '请选择角色', trigger: 'change' },
            // 可以添加其他验证规则
          ],
        },
        dataForm: {
          userType: 'visitor',
          userName: '',
          accountNo: '',
          roleIdList: [],
          status: true,
        }
      },
      exportUploadProperty: {
        config: {
          customAction: "/api/sys/sys-user/userImport", // 替换成你的上传地址
          accept: '.xls,.xlsx',
          headers: {
          },
          disabled: false,
          limit: 1,
          uploadData: {
            // 可选的上传数据
          },
          yourValue: [], // 双向绑定的值
        },
      },
      exportDialog: {
        visible: false,
      },
    }
  },
  created () {
    this.getData();
    this.getRoleList();
  },
  methods: {
    async getRoleList () {
      const res = (await roleList({ roleStatus: 1 })).data;
      this.formConfig.formItems[3].options = res.map(el => {
        return {
          ...el,
          id: el.roleId,
          label: el.roleName
        }
      });
    },

    async getData () {
      this.tableForm.checkList = [];
      const params = {
        pageNum: this.pageparm.currentPage,
        pageSize: this.pageparm.pageSize,
        ...this.formInline
      }
      const res = (await userPage(params)).data;
      this.tableForm.tableData = res.records;
      this.pageparm.total = res.total
    },
    search () {
      this.pageparm.currentPage = 1;
      this.getData()
    },


    handleEdit (index, row) {
      this.editFormVisible = true;
      this.formConfig.formItems[1].disable = false;
      this.formConfig.formItems[2].disable = false;
      if (row != undefined && row != 'undefined') {
        row.roleIdList = row.roleList.map(el => el.roleId);
        this.title = '修改用户'
        this.formConfig.dataForm = JSON.parse(JSON.stringify(row));
        this.formConfig.formItems[1].disable = true;
        this.formConfig.formItems[2].disable = true;
      } else {
        this.title = '新增用户'
        this.formConfig.dataForm = {
          userType: 'visitor',
          userName: '',
          accountNo: '',
          roleIdList: [],
          status: true,
        };
        if (this.$refs.editForm) {
          this.$refs.editForm.$refs.form.resetFields();
        }
      }
    },
    async resetPassword (index, row) {
      const res = await remakePasswd([row.userId]);
      this.$message.success('重置密码成功，密码为：123456');
      this.getData();
    },
    callFather (parm) {
      this.pageparm.currentPage = parm.currentPage
      this.pageparm.pageSize = parm.pageSize;
      this.getData()
    },
    async handleStatus (index, row) {
      const res = await userEnableOrDisable({ userIds: [row.userId], status: !row.status });
      this.$message.success(res.msg);
      this.getData();
    },
    // 关闭编辑、增加弹出框
    closeDialog (dialog) {
      this.$refs.editForm.$refs.form.resetFields();
      this.editFormVisible = false
    },
    async submitForm (editData) {
      let data = JSON.parse(JSON.stringify(this.formConfig.dataForm));
      this.$refs.editForm.$refs.form.validate(async valid => {
        if (valid) {
          // 请求方法
          const res = await (data.userId ? userEdit(data) : userAdd(data));
          this.closeDialog();
          await this.getData();
          this.$message.success(res.msg);
        } else {
          return false
        }
      })
    },
    dropdownBtn (index, data) {
      fileDownload(envConfig.NODE_API + '/templates/用户管理批量导入模板.xlsx', '用户管理批量导入模板.xlsx');
    },
    //导入
    showExportDialog () {
      this.exportDialog.visible = true
      this.exportDialog.tableData = { total: 0, failCnt: 0 };
      this.exportUploadProperty.config.yourValue = [];
    },
    closeExportDialog () {
      this.exportDialog.visible = false;
      this.getData();
      this.exportUploadProperty.config.yourValue = [];
    },
    exportRes () {
      return userImportRes();
    },
  },

}
</script>

<style lang="scss" scoped>
.user-search {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/system/user.vue